var React = require('react');

function LongArrowL (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M134.06 264H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.06v-46.059c0-21.382-25.852-32.09-40.972-16.97L7.03 207.029c-9.373 9.373-9.373 24.57 0 33.941l86.06 86.06c15.118 15.119 40.97 4.41 40.97-16.971z"}));
}

LongArrowL.defaultProps = {"viewBox":"0 0 448 448"};

module.exports = LongArrowL;

LongArrowL.default = LongArrowL;
